// extracted by mini-css-extract-plugin
export default {"root":"langSwitcher-module--root--l9p5C","active":"langSwitcher-module--active--rCpfb","list":"langSwitcher-module--list--ZRAnG","selected":"langSwitcher-module--selected--OeRfn"};